import React, { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import NoticeBoard from './NoticeBoard';
import {
  useGetNoticeBoardByIdQuery,
  useGetNoticeBoardsQuery,
} from '../redux/noticeBoardApi';
import { isProbablyHtml, stripDangerousHtml } from '../utils/notificationHtml';

function NoticeDetail() {
  const navigate = useNavigate();
  const { id } = useParams();
  const noticeId = Number(id);
  const { data: res } = useGetNoticeBoardByIdQuery(noticeId, {
    skip: Number.isNaN(noticeId),
  });
  const { data: listRes } = useGetNoticeBoardsQuery(undefined, {
    skip: Number.isNaN(noticeId),
  });
  const notice = res?.data;

  const sidebarNotices = useMemo(() => {
    const list = listRes?.data || [];
    if (!Array.isArray(list)) return [];
    return list
      .filter((n) => n.id !== noticeId)
      .slice()
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      .slice(0, 6);
  }, [listRes, noticeId]);

  return (
    <div className="min-h-[calc(100vh-130px)] bg-[#F7E5D5] px-4 py-4 sm:px-6 sm:py-6 lg:px-8">
      <div className="mx-auto grid max-w-6xl gap-6 md:grid-cols-[2fr_1fr]">
        <div className="py-6 ">
          <button
            type="button"
            onClick={() => navigate('/landing')}
            className="mb-4 inline-flex items-center gap-1 rounded-lg py-1.5 text-sm font-medium text-gray-800 transition"
            aria-label="Back to landing page"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
            >
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            Back
          </button>
          <h1 className="mb-2 text-2xl font-bold text-gray-900">
            Notice Detail
          </h1>
          {notice ? (
            <>
              {notice.description ? (
                isProbablyHtml(notice.description) ? (
                  <div
                    className="mb-4 text-sm text-gray-600 [&_h1]:mb-2 [&_h1]:text-lg [&_h1]:font-bold [&_h2]:mb-2 [&_h2]:text-base [&_h2]:font-semibold [&_p]:my-2 [&_strong]:font-semibold [&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5"
                    dangerouslySetInnerHTML={{
                      __html: stripDangerousHtml(notice.description),
                    }}
                  />
                ) : (
                  <p className="mb-4 text-sm text-gray-600">{notice.description}</p>
                )
              ) : null}
              <span className="inline-block rounded-full bg-[#D3A33D] px-3 py-1 text-xs font-semibold text-gray-900">
                {notice?.created_at
                  ? (() => {
                      const d = new Date(notice.created_at);
                      if (Number.isNaN(d.getTime())) return '';
                      return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
                    })()
                  : ''}
              </span>
            </>
          ) : (
            <p className="mb-4 text-sm text-gray-600">Loading notice...</p>
          )}
          {notice?.image?.url && (
          <div className="mt-6 overflow-hidden rounded-2xl">
            <img
              src={notice?.image?.url || ''}
              alt="Notice"
              className="h-[240px] w-full rounded-xl bg-white object-cover object-center shadow-sm ring-1 ring-black/5 sm:h-[320px] lg:h-[380px]"
            />
          </div>
          )}
        </div>
        <aside className="self-start">
          <NoticeBoard notices={sidebarNotices} />
        </aside>
      </div>
    </div>
  );
}

export default NoticeDetail;

